export default "__VITE_ASSET__DTMUHprZ__"